import { Component, ContentChild, ContentChildren, ElementRef, Input, QueryList } from '@angular/core';

@Component({
  selector: 'app-wrapper',
  standalone: false,
  templateUrl: './wrapper.html',
  styleUrl: './wrapper.scss',
})
export class Wrapper {

  @Input() hasMenu = false;


}
